/**
 * Manifest file for all Class modules that can be instantiated
 * by the main App.
 *
 * All modules should be alpha-ordered and imported using the async import syntax.
 * The key value for `name` should match the component `data-cmp-is` value, and the value should be the
 * component's import path
 * e.g.
 *  {
 *    name: 'accordion',
 *    loader: () => import('./components/modules/Accordion')
 *  }
 */
export const moduleMap = [
	{
		name: 'accordion',
		loader: () => import('./components/modules/Accordion')
	},
	{
		name: 'alert-banner',
		loader: () => import('./components/modules/AlertBanner')
	},
	{
		name: 'audio-carousel',
		loader: () => import('./components/modules/AudioCarousel')
	},
	{
		name: 'audio-carousel',
		loader: () => import('./components/modules/AudioCarousel')
	},
	{
		name: 'banner-email',
		loader: () => import('./components/modules/BannerEmail')
	},
	{
		name: 'card-carousel',
		loader: () => import('./components/modules/CardCarousel')
	},
	{
		name: 'card-carousel-gallery',
		loader: () => import('./components/modules/CardCarouselGallery')
	},
	{
		name: 'carousel',
		loader: () => import('./components/modules/Carousel')
	},
	{
		name: 'carouselAlt',
		loader: () => import('./components/modules/CarouselAlt')
	},
	{
		name: 'category-highlight',
		loader: () => import('./components/modules/CategoryHighlight')
	},
	{
		name: 'color-picker',
		loader: () => import('./components/modules/ColorPicker')
	},
	{
		name: 'comparison-slider',
		loader: () => import('./components/modules/ComparisonSlider')
	},
	{
		name: 'comparison-slider',
		loader: () => import('./components/modules/ComparisonSlider')
	},
	{
		name: 'cookie-banner',
		loader: () => import('./components/modules/CookieBanner')
	},
	{
		name: 'dollhouse',
		loader: () => import('./components/modules/DollhouseViewer/Dollhouse')
	},
	{
		name: 'dollhouse-viewer',
		loader: () => import('./components/modules/DollhouseViewer')
	},
	{
		name: 'dynamics-form',
		loader: () => import('./components/modules/DynamicsForm')
	},
	{
		name: 'favorites',
		loader: () => import('./components/modules/Favorites')
	},
	{
		name: 'footer',
		loader: () => import('./components/modules/Footer')
	},
	{
		name: 'header',
		loader: () => import('./components/modules/Header')
	},
	{
		name: 'hero-banner',
		loader: () => import('./components/modules/HeroBannerForm')
	},
	{
		name: 'hero-banner-form',
		loader: () => import('./components/modules/HeroBannerForm')
	},
	{
		name: 'lottie',
		loader: () => import('./components/modules/Lottie')
	},
	{
		name: 'modal',
		loader: () => import('./components/modules/Modal')
	},
	{
		name: 'modal-button',
		loader: () => import('./components/modules/ModalButton')
	},
	{
		name: 'product-information',
		loader: () => import('./components/modules/ProductInformation')
	},
	{
		name: 'product-listing',
		loader: () => import('./components/modules/ProductListing')
	},
	// {
	//   name: 'product-onboarding',
	//   loader: () => import('./components/modules/ProductOnboarding')
	// },
	{
		name: 'pinterest-gallery',
		loader: () => import('./components/modules/PinterestGallery')
	},
	{
		name: 'search-results',
		loader: () => import('./components/modules/SearchResults')
	},
	{
		name: 'side-nav-container',
		loader: () => import('./components/modules/SideNavContainer')
	},
	{
		name: 'social-share',
		loader: () => import('./components/modules/SocialShare')
	},
	{
		name: 'tabs',
		loader: () => import('./components/modules/Tabs')
	},
	{
		name: 'tabs-links',
		loader: () => import('./components/modules/TabsLinks')
	},
	{
		name: 'testimonial',
		loader: () => import('./components/modules/Testimonial')
	},
	{
		name: 'tile-grid',
		loader: () => import('./components/modules/TileGrid')
	},
	{
		name: 'where-to-buy',
		loader: () => import('./components/modules/WhereToBuy')
	},
	{
		name: 'where-to-buy-locator',
		loader: () => import('./components/modules/WhereToBuyLocator')
	},
	{
		name: 'sticky-jump-nav',
		loader: () => import('./components/modules/StickyJumpNav')
	},
	{
		name: 'video-modal',
		loader: () => import('./components/modules/VideoModal')
	},
	{
		name: 'video-player',
		loader: () => import('./components/modules/VideoPlayer')
	},
	{
		name: 'video-poster',
		loader: () => import('./components/modules/VideoPoster')
	}
]
